import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, restrictions, nextRestrictions }) =>
    present(
      repository
        .updateAccessRestrictions(planzone, restrictions, nextRestrictions)
        .then(() => ({
          planzone,
          restrictions: { ...restrictions, ...nextRestrictions },
        }))
        .catch(() =>
          Promise.reject({ planzone, restrictions, nextRestrictions }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
